<template>
  <beat-loader
    :color="color"
    :size="`${size}px`"
  />
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'

export default {
  name: "Loading",
  components: {
    BeatLoader,
  },
  props: {
    color: {
      type: String,
      default: "#263056",
    },
    size: {
      type: String,
      required: true,
      default: "22"
    },
  },
};
</script>